<template>
  <section class="content-inner position-relative">
    <div class="container-fluid">
      <div class="section-head text-center">
        <!-- <h6 class="text wow fadeInUp" data-wow-delay="0.6s">
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
        </h6> -->
        <h2 class="title wow fadeInUp text-primary" data-wow-delay="0.8s">
          {{ pageContent.title }}
        </h2>
      </div>
      <div class="row">
        <div class="col-xl-4 col-md-6 m-b30">
          <div
            class="dz-card style-1 overlay-shine wow fadeInUp"
            data-wow-delay="1.2s"
          >
            <div class="dz-media">
              <router-link to="/housing-resources"
                ><img src="assets/images/blog/1a.png" alt=""
              /></router-link>
            </div>
            <div class="dz-info">
              <h4 class="dz-title text-center">
                <router-link to="/housing-resources" class="text-center text-primary"
                  >{{ pageContent.housing_resources }}</router-link
                >
              </h4>
              <!-- <a href="javascript:void(0);" class="btn btn-primary">Read More</a> -->
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6 m-b30">
          <div
            class="dz-card style-1 overlay-shine wow fadeInUp"
            data-wow-delay="1.2s"
          >
            <div class="dz-media">
              <a href="javascript:void(0);"
                ><img
                  src="/assets/images/blog/2a.png"
                  alt=""
              /></a>
            </div>
            <div class="dz-info">
              <h4 class="dz-title text-center">
                <router-link to="/relocation-support" class="text-center text-primary"
                  >{{ pageContent.relocation_support }}</router-link
                >
              </h4>
              <!-- <a href="javascript:void(0);" class="btn btn-primary">Read More</a> -->
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6 m-b30">
          <div
            class="dz-card style-1 overlay-shine wow fadeInUp"
            data-wow-delay="1.0s"
          >
            <div class="dz-media">
              <a href="javascript:void(0);"
                ><img src="/assets/images/blog/3a.png" alt=""
              /></a>
              <!-- <span class="date"
                ><a href="javascript:void(0)">14 Feb 2012</a></span
              > -->
            </div>
            <div class="dz-info">
              <!-- <div class="dz-meta">
                <ul>
                  <li class="post-author text-primary">
                    <span>
                      <i class="fa-solid fa-user"></i>
                    </span>
                    By Kk Sharma
                  </li>
                  <li class="post-date text-primary">
                    <span>
                      <i class="fa-solid fa-message"></i>
                    </span>
                    24 Comments
                  </li>
                </ul>
              </div> -->
              <h4 class="dz-title text-center">
                <router-link to="/community" class="text-center text-primary"
                  >{{ pageContent.community_engangement }}</router-link
                >
              </h4>
              <!-- <a href="javascript:void(0);" class="btn btn-primary">Read More</a> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
            <div class="col-xl-12 col-lg-12 m-b30 m-t30 m-lg-t10">
              <nav aria-label="Blog Pagination">
                <ul
                  class="pagination style-1 text-center wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <li class="page-item">
                    <a class="page-link prev" href="javascript:void(0);"
                      ><i class="fas fa-chevron-left"></i
                    ></a>
                  </li>
                  <li class="page-item">
                    <a class="page-link active" href="javascript:void(0);">1</a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="javascript:void(0);">2</a>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="javascript:void(0);">3</a>
                  </li>
                  <li class="page-item">
                    <a class="page-link next" href="javascript:void(0);"
                      ><i class="fas fa-chevron-right"></i
                    ></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div> -->
    </div>
    <br>
    <router-link to="/explore"><button class="btn btn-primary d-block mx-auto" style="padding:15px 50px;border-radius:25px;">{{ pageContent.see_more }}</button></router-link>
  </section>
</template>

<script>
export default {
  props: {
    pageContent: {
      type: Object,
      required: true,
    },
  },
  // watch: {
  //   pageContent: {
  //     handler(newVal) {
  //       console.log('Child received new pageContent:', newVal);
  //     },
  //     deep: true,
  //   },
  // },
};
</script>